import { COLORS } from "../../../../../styles/variables";

export const BoxImg = {
  borderRadius: "50%", 
  width: "90px", 
  height: "90px", 
  objectFit: "cover", 
}

export const linkStyle = {
  minWidth: 0, 
  flex: 1, 
  overflow: "hidden", 
  textOverflow: "ellipsis", 
  color: COLORS.BLACK,
  fontSize: 14,
  fontWeight: 300,
  textDecoration: "none",
  "&:hover": { color: COLORS.BLACK, textDecoration: "none" },
  "&:visited": { color: COLORS.BLACK },
}